import React, { Fragment } from 'react';

import { Col, Row, Space } from 'antd';
import { Link } from 'react-router-dom';
import { MTypography } from 'src/lib';

import * as Styles from './About.styles';

export const About = () => {
  return (
    <Fragment>
      <Row className={Styles.missionSection}>
        <Col span={24} className={Styles.sectionContainer}>
          <Space direction='vertical' className={Styles.missionContainer}>
            <MTypography variant='h3' weight='bold' className={Styles.missionHeader}>
              About My IPO
            </MTypography>
            <MTypography variant='subtitle1' weight='normal' className={Styles.missionSubtext}>
              At My IPO, our mission is to provide open access to selected IPOs and other Offerings.
            </MTypography>
          </Space>
        </Col>
      </Row>
      <Row className={Styles.aboutTextSection} justify='center'>
        <Col span={24} className={Styles.aboutTextSectionContainer}>
          <div className={Styles.aboutTextContainer}>
            <MTypography variant='body1'>
              Until now, only the privileged clients of investment banks, institutional investors or the wealthy had
              access to IPOs and other Offerings. My IPO has changed this by creating a marketplace of selected IPOs and
              other Offerings that everyone can invest in.
            </MTypography>
            <MTypography variant='body1'>
              We believe that access to wealth creation should be universal and not just available to those that already
              have wealth or privileged access to these types of Offerings. My IPO was created to give all investors the
              opportunity to invest in some of the most exciting IPOs and other Offerings. It’s easy to sign up, easy to
              use and equally easy to find Offerings to invest in.
            </MTypography>
            <MTypography variant='body1'>
              Please join us as we continue to fight for equal access to wealth creation.
            </MTypography>
          </div>
          <div className={Styles.aboutTextContainer}>
            <MTypography variant='h6' weight='bold' className={Styles.aboutTextContainerTitle}>
              Contact Us
            </MTypography>
            <MTypography variant='body1'>
              If you have any questions please email us at&nbsp;
              <a href='mailto:clientservices@myipo.com'>clientservices@myipo.com</a>&nbsp;or give us a call at the
              telephone number below. We’re available to help from 7:30am-4pm MST, Monday through Friday.
            </MTypography>
            <MTypography variant='body1'>
              My IPO
              <br />
              311 S Wacker Dr, Suite 1775
              <br />
              Chicago, IL 60606
              <br />
              Toll Free: (844) 226-0640
              <br />
              <a href='.'>www.myipo.com</a>
            </MTypography>
          </div>
        </Col>
      </Row>
      <Row className={Styles.signupSection}>
        <Col span={24} className={Styles.signupContainer}>
          <MTypography variant='h3' weight='bold' className={Styles.signupTextHeader}>
            Get started today!
          </MTypography>
          <Link className={Styles.signupBtn} to={'/register'}>
            Sign up
          </Link>
        </Col>
      </Row>
    </Fragment>
  );
};

export default About;
